var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00149 15.215C1.56492 15.215 1.1912 15.0596 0.880347 14.7488C0.569491 14.4379 0.414062 14.0642 0.414062 13.6276V6.12974C0.414062 5.87845 0.470262 5.6404 0.582662 5.4156C0.695209 5.19066 0.850637 5.00545 1.04895 4.85997L6.04767 1.1027C6.32501 0.890921 6.64201 0.785034 6.99868 0.785034C7.35534 0.785034 7.67322 0.890921 7.95232 1.1027L12.951 4.85997C13.1494 5.00545 13.3048 5.19066 13.4173 5.4156C13.5297 5.6404 13.5859 5.87845 13.5859 6.12974V13.6276C13.5859 14.0642 13.4305 14.4379 13.1196 14.7488C12.8088 15.0596 12.4351 15.215 11.9985 15.215H2.00149Z",
    fill: "#3C5F7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.41bf0030063f05abb2c4d59ea4f88169.svg";
export { ForwardRef as ReactComponent };